<template>
  <div class="banner wallet-banner">
    <div class="banner__inner wallet-banner__inner">
      <div class="banner__left">
        <h3 class="banner__title wallet-banner__title">
          {{$t('wallet_banner.title')}}
        </h3>
        <div class="banner__description wallet-banner__description">
          {{$t('wallet_banner.description')}}
        </div>
      </div>
      <div class="banner__right">
        <div class="banner__img">
          <img
            src="@/assets/img/wallet.jpg"
            alt="banner-img"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  setup() {
    const { t } = useI18n();
    return {
      t
    };
  },
});
</script>
<style lang="scss" scoped>
.wallet-banner{
    &__inner{
      height: 100%;
    }
    &__title{
        width: 90%;
        margin-bottom: 68px;
    }
}
@media (min-width: 320px) and (max-width: 768px) {
    .wallet-banner{
    &__title{
        width: 100%;
        margin-bottom: 16px;
    }
}
}
</style>